import MasterRoleAddPage from './MasterRoleAddPage';

export default MasterRoleAddPage;
